var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAgeRating7 = function SvgAgeRating7(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2497 0C19.7686 0 21 1.23137 21 2.75034V18.2497C21 19.7686 19.7686 21 18.2497 21H2.75034C1.23137 21 0 19.7686 0 18.2497V2.75034C0 1.23137 1.23137 0 2.75034 0H18.2497Z",
    fill: "#4C8FB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.84 16.056C11.2987 14.328 11.84 12.6827 12.464 11.12C13.088 9.55733 13.8213 8.00267 14.664 6.456V6.456V5H7V6.6H12.616C11.08 9.544 9.81067 12.696 8.808 16.056V16.056H10.84Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgeRating7, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/age_rating_7.d18c98fa.svg";
export { ForwardRef as ReactComponent };